<template>
  <v-row justify="center" :class="`pricing-${$mq}`">
    <v-col cols="12">
      <v-row wrap>
        <v-col
          cols="12"
          sm="10"
          md="10"
          lg="7"
          :class="['mx-auto', $mq === 'xs' ? 'mt-3' : 'mt-10']"
        >
          <div class="display-2 font-weight-bold my-2 text-center">
            Get out of your inbox<br v-if="$mq !== 'xs'" /><span
              v-else
              v-html="'&nbsp;'"
            />and back to your kitchen.
          </div>
          <v-row>
            <v-col class="text-center my-3">
              <div class="mx-auto text-left d-inline-block">
                <template v-for="(feat, i) of headerFeatures">
                  <div
                    :class="[
                      'feature-item',
                      visibleFeatures > i ? 'show' : 'hide',
                    ]"
                    :key="i"
                  >
                    <v-icon class="mb-2" color="green" left>mdi-check</v-icon>
                    <span class="text-h5">{{ feat }}</span>
                  </div>
                </template>
              </div>
            </v-col>
          </v-row>
          <!-- <transition name="fade-in-left" appear> -->

          <v-card class="px-3 px-sm-14 py-8 mt-4" outlined>
            <v-row align-items="center">
              <v-col cols="12" md="6">
                <div class="display-1 font-weight-bold text-center text-md-left"
                  >Use Minimart completely free for 30 days or until you've sold
                  $1,000.</div
                >
              </v-col>
              <v-col
                cols="12"
                md="5"
                offset-md="1"
                align-self="center"
                class="text-center"
              >
                <div class="title font-weight-bold mb-2"
                  >and after your trial:</div
                >
                <div class="blue--text text--darken-2" flat>
                  <div class="display-2 font-weight-bold">
                    <span class="ml-3">$7</span
                    ><span class="slash-month headline font-weight-bold"
                      >/month</span
                    >
                  </div>
                  <div class="headline font-weight-bold">
                    + 1% of orders
                  </div>
                  <div class="font-italic">
                    and a 5% Service Fee for customers
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>

          <!-- </transition> -->
        </v-col>
        <v-col cols="12" lg="12" class="mx-auto text-center">
          <div class="display-1 my-4 text-center font-italic">
            Join all types of food businesses across the US
          </div>
          <transition name="fade-up" appear>
            <v-btn
              v-if="btnsAppear"
              x-large
              dark
              depressed
              rounded
              class="ma-2"
              color="blue darken-1"
              to="/signup"
              >Try it Free</v-btn
            >
          </transition>
        </v-col>
      </v-row>
      <v-divider class="my-6" />
      <v-row class="py-0 py-sm-10">
        <v-col cols="12" md="8" class="mx-auto">
          <v-row>
            <v-col cols="12" sm="5" class="px-0 pr-md-4">
              <CostEstimator />
            </v-col>
            <v-col cols="12" sm="7" class="pl-0 pl-sm-8"
              ><h2 class="display-1 font-weight-bold mb-4">
                Get A Feel For Your Costs
              </h2>
              <p class="title"
                >We know in the food business not all months are the same.
                That's why Minimart's pricing adapts to your growth. Use the
                estimator here to see how the monthly fee changes with your
                sales.</p
              >
            </v-col>
            <v-col cols="12" lg="12" class="mx-auto text-center">
              <v-btn
                outlined
                x-large
                dark
                depressed
                rounded
                class="ma-2"
                color="blue darken-1"
                to="/signup"
                >Start Selling Now</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-6" />
      <v-row class="py-0 py-sm-10">
        <v-col cols="12" sm="8" class="mx-auto">
          <v-row>
            <v-col cols="12" sm="6">
              <h2 class="display-1 font-weight-bold mb-4 mt-4 mt-sm-10">
                Have a question?
              </h2>
              <div class="headline"
                >Send us a message and we'll respond as soon as we can.</div
              >
            </v-col>
            <v-col cols="12" sm="5" offset-sm="1">
              <transition name="fade" mode="out-in">
                <v-alert
                  type="success"
                  class="mt-10 title"
                  text
                  prominent
                  v-if="success"
                >
                  Thanks for your message. Someone will contact you to follow
                  up.
                </v-alert>
                <v-form
                  ref="inquiry"
                  v-else
                  v-model="isFormValid"
                  @submit.prevent="submitAction"
                  :disabled="isSending"
                >
                  <v-text-field
                    v-model="name"
                    outlined
                    color="blue darken-1"
                    label="Full Name*"
                    name="Full Name"
                    large
                    :rules="[rules.required]"
                  />
                  <v-text-field
                    v-model="email"
                    outlined
                    color="blue darken-1"
                    name="Email"
                    label="Email*"
                    large
                    :rules="[rules.required, rules.email]"
                  />
                  <v-textarea
                    v-model="msgDetails"
                    outlined
                    color="blue darken-1"
                    name="Details"
                    :rules="[rules.required]"
                    label="How can we help?*"
                    rows="2"
                  />
                  <v-btn
                    outlined
                    tile
                    class="ml-0"
                    color="blue darken-1"
                    type="submit"
                    :disabled="isSending"
                    :loading="isSending"
                    >Send</v-btn
                  >
                </v-form>
              </transition>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-6" />
      <v-row wrap class="py-10">
        <v-col col="12" lg="10" xl="8" class="mx-auto">
          <v-row wrap class="text-center mx-0 mx-sm-6" justify="center">
            <v-col
              cols="12"
              sm="6"
              class="py-6 px-0 px-sm-10"
              align-self="center"
            >
              <div class="display-1 my-4 text-center font-weight-bold">
                Getting Started Is A Piece Of Cake
              </div>
              <v-btn to="/faq" dark large outlined color="blue darken-1"
                >Visit the Setup Guide</v-btn
              >
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="py-6 px-0 px-sm-10"
              align-self="center"
            >
              <div class="display-1 my-4 text-center font-weight-bold">
                Meet Some Minimart Users
              </div>
              <v-btn
                to="/minimart-community"
                dark
                large
                outlined
                color="blue darken-1"
                >Explore the Community</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import EmailService from '@/services/EmailService'

import CostEstimator from '@/components/CostEstimator'
export default {
  name: 'PricingView',
  components: { CostEstimator },
  computed: {},
  meta() {
    return {
      title: 'Minimart | Pricing - Start Your Free Trial Today',
      meta: [
        {
          name: 'description',
          content: 'Fall in love with Minimart before paying a dime.',
        },
      ],
    }
  },
  data() {
    return {
      btnsAppear: true,
      play: true,
      visibleFeatures: 0,
      featureInterval: null,
      headerFeatures: [
        'Hosted Menu and Website',
        'Order & Payment Management',
        'Customer Messaging',
      ],
      name: '',
      email: '',
      msgDetails: '',
      isSending: false,
      success: false,
      error: false,
      isFormValid: false,
      rules: {
        required: (v) => !!v || 'This field is required',
        email: (email) => {
          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return re.test(email) || 'Please enter a valid email'
        },
      },
    }
  },
  created() {
    setTimeout(() => {
      this.btnsAppear = true
    }, 1500)
    setTimeout(() => {
      this.featureInterval = setInterval(() => {
        this.visibleFeatures++
        if (this.visibleFeatures >= this.headerFeatures.length) {
          clearInterval(this.featureInterval)
        }
      }, 400)
    }, 400)
  },
  methods: {
    async submitAction() {
      if (!this.isFormValid) return

      this.isSending = true
      this.success = false
      this.error = false

      try {
        let { name, email, msgDetails } = this
        let res = await EmailService.pricingInquiry({
          name,
          email,
          msgDetails,
        })
        this.$refs.inquiry.reset()
        this.success = true
        setTimeout(() => {
          this.success = false
        }, 10000)
        return res
      } catch (error) {
        this.error = true
        return Promise.reject(Error(error))
      } finally {
        this.isSending = false
      }
    }, // submitAction
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.price-box {
  border: 1px solid gray;
  max-width: 150px;
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: opacity 1s, transform 1s ease-in-out;
}
.fade-up-enter, .fade-up-leave-to /* .fade-up-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30%);
}

.fade-in-left-enter-active,
.fade-in-left-leave-active {
  transition: opacity 1.2s, transform 1.2s ease-in-out;
}
.fade-in-left-enter, .fade-in-left-leave-to /* .fade-in-left-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-20px);
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0.1;
  transform: translateX(-20%);
}
.feature-item {
  transition: all 0.7s ease-out;
  &.hide {
    opacity: 0;
    transform: translateX(-20%);
  }
}
</style>
